export type SortContext = 'early' | 'standard';

type SortMeasurement = { durationMs: number; context: SortContext };

type HsResourcesWindow = Window & {
  __hsResources?: {
    crmSearchSortDurations?: SortMeasurement[];
  };
};

function getWindow(): HsResourcesWindow {
  return window as HsResourcesWindow;
}

export function recordSortDuration({
  durationMs,
  context,
}: {
  durationMs: number;
  context: SortContext;
}): void {
  const w = getWindow();
  w.__hsResources ??= {};
  w.__hsResources.crmSearchSortDurations ??= [];
  w.__hsResources.crmSearchSortDurations.push({ durationMs, context });
}

function isValidMeasurement(item: unknown): item is SortMeasurement {
  return (
    item !== null &&
    typeof item === 'object' &&
    typeof (item as SortMeasurement).durationMs === 'number' &&
    ((item as SortMeasurement).context === 'early' ||
      (item as SortMeasurement).context === 'standard')
  );
}

export function drainSortDurations(): SortMeasurement[] {
  return (
    getWindow().__hsResources?.crmSearchSortDurations?.splice(0) ?? []
  ).filter(isValidMeasurement);
}
